// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"32c88f4f","119":"67dd61ad","321":"fe79df4c","332":"5aa4fe4b","349":"a067853f","387":"b221ad86","498":"1bc8f6f1","500":"e1b7adc7","573":"684ff7f2","643":"a1d5496b","817":"518c9e6f","858":"0a4eddf1"}[chunkId] + ".chunk.js";
};